
import { Component, Vue, Prop } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
@Component({
  components: {
    CommonBlockLine,
  },
})
export default class ReportClass extends Vue {
  @Prop() private config;

  get isShow() {
    return this.config.isShow && this.config.text;
  }
  aciton() {
    // 跳转到更多
    this.$emit('action', this.config);
  }
}
